module.exports = __webpack_public_path__ + "img/address.c5d66586.svg";